<template>
  <div>
    <v-card>
      <v-card-title class="grey--text"> Ordini Attivi </v-card-title>
      <v-card-text>
        Ci sono
        <span style="font-size: 22px" class="green--text">{{
          n_ordini_nuovi
        }}</span>
        Nuovi Ordini
        <br />
        Ci sono
        <span style="font-size: 22px" class="pink--text">{{
          n_ordini_attivi
        }}</span>
        Ordini Attivi
        <v-list>
          <OrdineAttivoElement
            v-for="ordine in ordini_attivi"
            :key="ordine._id.$oid"
            :ordine="ordine"
          />
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="green" to="/ordini">Vedi Tutti</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="my-4">
      <v-card-title class="grey--text"> Messaggi</v-card-title>
      <v-card-text>
        Ci sono
        <span style="font-size: 22px" class="blue--text">{{ n_chat_nl }}</span>
        Messaggi da Leggere
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="blue" to="/chat">Vedi Tutti</v-btn>
      </v-card-actions>
    </v-card>
    <ClientiOnline />
  </div>
</template>

<script>
import ClientiOnline from "../../Statistiche/mobile/clienti_oniline_mobile/clienti_attivi_mobile.vue";
import OrdineAttivoElement from "../../Ordini/mobile/ordine_attivo_element.vue";
export default {
  components: {
    ClientiOnline,
    OrdineAttivoElement,
  },
  computed: {
    n_ordini_nuovi() {
      return this.$store.getters.get_ordini_nuovi;
    },
    n_ordini_attivi() {
      return this.$store.getters.get_numero_ordini_attivi;
    },
    n_conteggi() {
      return this.$store.getters.get_numero_conteggi;
    },
    n_chat_nl() {
      return this.$store.getters.get_chats_nl;
    },
    utenti_online() {
      return this.$store.getters.get_clienti_online;
    },
    ordini_attivi() {

      return this.$store.getters.get_ordini_attivi.slice(0, 2);
    },
  },
};
</script>